"use strict";
exports.__esModule = true;
exports.POSITIONS = exports.COLORS = void 0;
exports.COLORS = {
    primary: '!bg-primary before:border-primary text-primary-100',
    secondary: '!bg-secondary before:border-secondary text-secondary-100',
    tertiary: '!bg-tertiary before:border-tertiary text-tertiary-100',
    info: '!bg-info before:border-info text-info-100',
    success: '!bg-success before:border-success text-success-100',
    danger: '!bg-danger before:border-danger text-danger-100',
    warning: '!bg-warning before:border-warning text-warning-100',
    control: '!bg-control before:border-control text-control-100',
    white: '!bg-white before:border-white text-black',
    black: '!bg-black before:border-black text-white',
    inherit: '!bg-black before:border-black text-white',
    slate: '!bg-slate-500 before:border-slate-500 text-slate-100',
    zinc: '!bg-zinc-500 before:border-zinc-500 text-zinc-100',
    neutral: '!bg-neutral-500 before:border-neutral-500 text-neutral-100',
    stone: '!bg-stone-500 before:border-stone-500 text-stone-100',
    red: '!bg-red-500 before:border-red-500 text-red-100',
    orange: '!bg-orange-500 before:border-orange-500 text-orange-100',
    amber: '!bg-amber-500 before:border-amber-500 text-amber-100',
    yellow: '!bg-yellow-500 before:border-yellow-500 text-yellow-100',
    lime: '!bg-lime-500 before:border-lime-500 text-lime-100',
    green: '!bg-green-500 before:border-green-500 text-green-100',
    emerald: '!bg-emerald-500 before:border-emerald-500 text-emerald-100',
    teal: '!bg-teal-500 before:border-teal-500 text-teal-100',
    cyan: '!bg-cyan-500 before:border-cyan-500 text-cyan-100',
    sky: '!bg-sky-500 before:border-sky-500 text-sky-100',
    blue: '!bg-blue-500 before:border-blue-500 text-blue-100',
    indigo: '!bg-indigo-500 before:border-indigo-500 text-indigo-100',
    violet: '!bg-violet-500 before:border-violet-500 text-violet-100',
    purple: '!bg-purple-500 before:border-purple-500 text-purple-100',
    fuchsia: '!bg-fuchsia-500 before:border-fuchsia-500 text-fuchsia-100',
    pink: '!bg-pink-500 before:border-pink-500 text-pink-100',
    rose: '!bg-rose-500 before:border-rose-500 text-rose-100'
};
exports.POSITIONS = {
    top: 'mb-2 before:-bottom-2 bottom-[100%] before:!rotate-180',
    bottom: 'mt-2 before:-top-2 top-[100%]',
    left: 'mr-2 before:-right-2.5 right-[100%] before:!rotate-90',
    right: 'ml-2 before:-left-2.5 left-[100%] before:!-rotate-90'
};
//# sourceMappingURL=tooltip.style.js.map